module.exports = __webpack_public_path__ + "images/urbee85cc4b268ff90ec8bfe179748e1c2dfe.png";